/*eslint-disable */

import axios from 'axios';
import {
  mapGetters
} from 'vuex';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery'); 



let removedAproveLeaveApiUrl = root.removedAproveLeaveApiUrl.link;
export default {
  name: 'leave-list-of-manager',
  components: {},
  props: [],
  data () {
    return {
      employeeLeaveList:null,
      employeeLeaveListResults:[],
      nextStep:'',
      loadmoreData: {},
      userLoading: false,
      submitted:false,
      countryList:[],
      leaveRejectState:false,
      leaveApproveState:false,
      removeLeaveId:'',
      nextPageUrl:null,
      is_rejected:false,
      is_approved:false,
      search_term:'',
      allLeaveListState:true,
      searchEmployeeLeaveList:[],
      totalLeaveOfEmpl:'',
      removedLeaveState:false,
      leaveRemovedId:'',
      filterManagerLeaveState:'',
      lStaffData:null,
      lStaffDataResults:[],
      yearState:'2025',
      monthState:'0'
    }
  },
  computed: {
  ...mapGetters([
    'getAdminOfEmployeeLeaveListGetters',
  ]),
  getEmployeeLeaveListFun(){
   this.employeeLeaveList = this.$store.getters.getAdminOfEmployeeLeaveListGetters.data
   return 
  },
  SetIntialStatus() {
    if (this.employeeLeaveList) {
      this.nextStep = this.employeeLeaveList.next
      this.nextPageUrl = this.employeeLeaveList.next
      this.employeeLeaveListResults = this.employeeLeaveList.results
    }
  },
  },
  mounted () {
    this.getEmployeeLeaveListFun
    this.SetIntialStatus
    this.$store.dispatch('getStafListForManagerAction').then((res) => {
      this.lStaffData = res.data.data.results
      this.lStaffDataResults = this.lStaffData.results 
    })
  },
  methods: {
    filterManagerLeaveMethod(){
      if(this.filterManagerLeaveState != ''){
        this.userLoading = true
        this.allLeaveListState = false
        let data = {
          user_id:this.filterManagerLeaveState,
          year:this.yearState,
          month:this.monthState
        }
        this.$store.dispatch('getManagerLeaveFilterApiUrlFun', data).then((response) => {
          this.totalLeaveOfEmpl = response.data.data.results.total_leaves
          this.searchEmployeeLeaveList = response.data.data.results.user_leaves
          this.userLoading = false
        })
      }else{
        this.yearState = ''
        this.monthState = ''
        this.userLoading = true
        this.$store.dispatch('getAdminOfEmployeeLeaveListFun').then((res)=>{
          this.allLeaveListState = true
          this.searchEmployeeLeaveList = []
          this.userLoading = false
        })
      }
      
      // this.$validator.validateAll().then((result) => {
      //   if (result) {
      //     if(this.search_term.length >= 3){
      //       this.allLeaveListState = false
      //       this.$store.dispatch('searchAdminOfEmployeeLeaveListFun', { search_term: this.search_term }).then((response) => {
      //         this.totalLeaveOfEmpl = response.data.data.total_leaves
      //         this.searchEmployeeLeaveList = response.data.data.results
      //       })
      //     }else{
      //       this.$store.dispatch('getAdminOfEmployeeLeaveListFun').then((res)=>{
      //         this.allLeaveListState = true
      //         this.searchEmployeeLeaveList = []
      //       })
      //     }
      //   }
      // })
    },
    getLeaveListAgain() {
      this.$store.dispatch('getAdminOfEmployeeLeaveListFun').then((res) => {
      }).catch((err) => {
      })
    },
    showRejectModalFun(id, is_rejected){
      document.body.classList.add('body_right_scroll_remove');
      this.leaveRejectState = true
      this.removeLeaveId = id
      if(is_rejected === true){
        this.is_rejected = false
      }else{
        this.is_rejected = true
      }
    },
    rejectModalItemConfirmMethod(){
      let data = {
        is_rejected:this.is_rejected
      }
      this.$store.dispatch('updateEmployeeLeaveInfoFun', {data:{id: this.removeLeaveId,data:data}})
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          document.body.classList.remove('body_right_scroll_remove');
          this.leaveRejectState = false
          this.removeLeaveId = ''
          this.getLeaveListAgain()
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRejectItemModalFun(){
      document.body.classList.remove('body_right_scroll_remove');
      this.leaveRejectState = false;
      this.taskDeleteId = '';
    },
    showApproveModalFun(id, is_rejected){
      document.body.classList.add('body_right_scroll_remove');
      this.leaveApproveState = true;
      this.removeLeaveId = id;
      if(is_rejected === true){
        this.is_approved = false;
      }else{
        this.is_approved = true;
      }
    },
    approveModalItemConfirmMethod(){
      let data = {
        is_approved:this.is_approved
      }
      this.$store.dispatch('updateEmployeeLeaveInfoFun', {data:{id: this.removeLeaveId,data:data}})
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); ;
          document.body.classList.remove('body_right_scroll_remove');
          this.leaveApproveState = false;
          this.removeLeaveId = '';
          this.getLeaveListAgain();
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeApproveItemModalMethod(){
      document.body.classList.remove('body_right_scroll_remove');
      this.leaveApproveState = false;
      this.taskDeleteId = '';
    },
    showLoadMoreDataMethod(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.employeeLeaveListResults, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.employeeLeaveListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    validateSearchLeaveBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.search_term.length >= 3){
            this.allLeaveListState = false
            this.$store.dispatch('searchAdminOfEmployeeLeaveListFun', { search_term: this.search_term }).then((response) => {
              this.totalLeaveOfEmpl = response.data.data.total_leaves
              this.searchEmployeeLeaveList = response.data.data.results
            })
          }else{
            this.$store.dispatch('getAdminOfEmployeeLeaveListFun').then((res)=>{
              this.allLeaveListState = true
              this.searchEmployeeLeaveList = []
            })
          }
        }
      })
    },
    showRemoveModalMethod(id){
      document.body.classList.add('body_right_scroll_remove');
      this.removedLeaveState = true
      this.leaveRemovedId = id
    },
    removeModalItemConfirmMethod(){
      axios.delete(removedAproveLeaveApiUrl + this.leaveRemovedId + '/').then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          this.getLeaveListAgain();
          this.closeRemoveItemModalMethod();
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    },
    closeRemoveItemModalMethod(){
      document.body.classList.remove('body_right_scroll_remove');
      this.leaveRejectState = false;
      this.removedLeaveState = false;
      this.leaveRemovedId = '';
    },
  },
  watch:{
    nextStep(old_val, new_val){
      if(new_val != ''){
        this.nextPageUrl = new_val
      }
    },
    getEmployeeLeaveListFun(){
      return  this.$store.getters.getAdminOfEmployeeLeaveListGetters
    },
    SetIntialStatus() {
      if (this.employeeLeaveList) {
        this.employeeLeaveListResults = this.employeeLeaveList.results
      }
    },
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    document.body.classList.remove('body_right_scroll_remove');
    next();
  },
}